// Заменяет в html-контенте маркеры вида [codeblock content=[`строка`, `строка`] /]
// на блок кода <div class="code-box"><pre><code>...</code></pre></div>

// Конец маркера — `] с необязательным /], после которого не идёт продолжение списка строк.
// Необязательные <p>/</p> вокруг маркера съедаем, чтобы не оставлять пустых абзацев.
export const CODE_BLOCK_REGEX = /(?:<p>\s*)?\[codeblock\s+content=\[([\s\S]*?)`\s*\]\s*(?:\/\])?(?!\s*[`,])(?:\s*<\/p>)?/g;

const escapeHtml = (str) =>
  str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

// Редактор отдаёт содержимое маркера уже HTML-экранированным (`=>` приходит как `=&gt;`),
// поэтому перед повторным экранированием возвращаем исходные символы. `&amp;` — последним.
const decodeHtml = (str) =>
  str
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0?39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&');

// Разбирает содержимое content=[...] на строки кода
const parseCodeLines = (rawContent) => {
  const lines = rawContent
    .split(/`\s*,\s*`/) // строки разделены запятой между бэктиками
    .map((piece) => piece.replace(/^\s*`+/, '').replace(/`+\s*$/, '')) // оставшиеся обрамляющие бэктики
    .map((piece) => piece.replace(/<\/?p>/g, '')) // теги <p>, добавленные редактором внутрь кода
    .map(decodeHtml)
    .reduce((acc, piece) => {
      const pieceLines = piece.split(/\r?\n/).map((line) => line.replace(/\s+$/, ''));

      // Пустые строки по краям куска — мусор от разбиения редактором на абзацы
      while (pieceLines.length && !pieceLines[0]) pieceLines.shift();
      while (pieceLines.length && !pieceLines[pieceLines.length - 1]) pieceLines.pop();

      // Полностью пустой кусок (``) — намеренная пустая строка, оставляем.
      // Пустые строки внутри куска тоже сохраняются.
      acc.push(...(pieceLines.length ? pieceLines : ['']));
      return acc;
    }, []);

  // Пустые строки в начале и конце всего блока не нужны
  while (lines.length && !lines[0]) lines.shift();
  while (lines.length && !lines[lines.length - 1]) lines.pop();

  return lines;
};

export function replaceCodeBlocks(html, { copyLabel = 'Copy', copiedLabel = 'Copied!' } = {}) {
  if (!html || typeof html !== 'string') return html;

  return html.replace(CODE_BLOCK_REGEX, (_match, rawContent) => {
    const lines = parseCodeLines(rawContent);

    if (!lines.length) return '';

    const copyButton = `<button class="copy-btn" type="button" data-copied-label="${escapeHtml(
      copiedLabel
    )}">${escapeHtml(copyLabel)}</button>`;

    return `<div class="code-box">${copyButton}<pre><code>${lines.map(escapeHtml).join('\n')}</code></pre></div>`;
  });
}
